
export default class globalVariables {

    static IP_ADDRESS = "ip_address"

    static AUTH_TOKEN = "auth_token"
    static REFRESH_TOKEN = "refresh_token"
    static TOKEN_EXPIRY = "token_expiry"

    static USER_TYPE = "user_type"
    static USER_NAME = "user_name"
    static USER_PASSWORD = "user_password"
    static USER_EMAIL = "user_email"
    static USER_ID = "user_id"
    static DEALER_UUID = "dealer_uuid"

    static USER_TYPE_ADMIN = 'admin'
    static USER_TYPE_OPERATOR = 'operator'
    static USER_TYPE_SUPERVISOR = 'supervisor'

    static USER_STATE_ACTIVE = 1
    static USER_STATE_INACTIVE = 0

    static USER_ACCESS_ALLOW = 1
    static USER_ACCESS_DENY = 0

    static BATCHES_DATA = "batches_data"
    static WIFI_DATA = "wifi_data"

    static CAMERA_ID = "camera_id"
    static DEVICE_ID = "device_id"
    static DEVICE_NAME = "device_name"
    static SITE_ID = "site_id"
    static SITE_NAME = "site_name"

}